import React, { Component } from "react";
import { connect } from "react-redux";
import IntlMessages from "../utils/IntlMessages";
import { Link } from "react-router-dom";

import { checkLogin } from "./../utils/apiUtil";
import {
 
  walletDetailFetch,
 
} from "../actions";

class Breadcrumb extends Component {
  componentDidMount() {}



  renderBreadcrumb_li(subpath , path){

      switch (subpath) {
        case "/":
          return (<li className="breadcrumb-item">
                <Link to="/">
                  <IntlMessages id="header.home"></IntlMessages>
                </Link>
              </li>)

        case "/privilege":
          return (  <li className="breadcrumb-item active" aria-current="page">
          <Link to="/privilege" className="active">
            <IntlMessages id="header.privilege"></IntlMessages>
          </Link>
        </li>)

        case "/faq":
          return (  <li className="breadcrumb-item active" aria-current="page">
          <Link to="/faq" className="active">
                  <IntlMessages id="header.faq"></IntlMessages>
                </Link>
        </li>)
 
        case "/term":
          return (   <li className="breadcrumb-item active" aria-current="page">
          <Link to="/term" className="active">
            <IntlMessages id="header.term"></IntlMessages>
          </Link>
        </li>)     

        case "/contact":
          return (   <li className="breadcrumb-item active" aria-current="page">
          <Link to="/contact" className="active">
            <IntlMessages id="header.contact"></IntlMessages>
          </Link>
        </li>)   

        case "/my-coupon":
          return (   <li className="breadcrumb-item active" aria-current="page">
          <Link to="/my-coupon" className="active">
            <IntlMessages id="header.mycoupon"></IntlMessages>
          </Link>
        </li>)   

        case "/my-profile":
          return (   <li className="breadcrumb-item active" aria-current="page">
          <Link to="/my-profile" className="active">
            <IntlMessages id="header.profile"></IntlMessages>
          </Link>
        </li>) 

        // case "/history":
        //   return (   <li className="breadcrumb-item active" aria-current="page">
        //   <Link to="/history" className="active">
        //     <IntlMessages id="header.redeem-history"></IntlMessages>
        //   </Link>
        // </li>) 


        case "/point-transfer":
          return (   <li className="breadcrumb-item active" aria-current="page">
          <Link to="/history/point-transfer" className="active">
            <IntlMessages id="header.point-history"></IntlMessages>
          </Link>
        </li>) 

        case "/point-expire":
          return (   <li className="breadcrumb-item active" aria-current="page">
          <Link to="/history/point-transfer" className="active">
            <IntlMessages id="header.point-history"></IntlMessages>
          </Link>
        </li>) 

       
      }
  }

  render() {
    const { path, authMember, currentPoint } = this.props;
    
    if(!currentPoint && checkLogin()===true){
      this.props.walletDetailFetch()
    }
    
    return (
      <div className="header-breadcrumb d-none d-md-block">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
           {
             path && path.split("/").map( (sub_path ,index)=> { 


               if(index > 0 && sub_path === "") return ("")



              return this.renderBreadcrumb_li(`/${sub_path}`, path )
             })
           }
           
            {authMember && authMember.success ? (
            <li className="ml-auto"   
                style={{
                  listStyleType: "none",
                  paddingRight: 30,
                  fontWeight: "bold",
                  color: "white"
                }}>  {currentPoint ? currentPoint.toLocaleString("en-US") : ""} Points</li>
                ) : ""}
            
          </ol>
        </nav>
      </div>
    );


    if (path === "/") { 
      
    } 
    else if (path === "/privilege") {
      return (
        <div className="header-breadcrumb d-none d-md-block">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">
                  <IntlMessages id="header.home"></IntlMessages>
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                <Link to="/privilege" className="active">
                  <IntlMessages id="header.privilege"></IntlMessages>
                </Link>
              </li>
              {authMember && authMember.success ? (
              <li className=" ml-auto"   
                  style={{
                    listStyleType: "none",
                    paddingRight: 30,
                    fontWeight: "bold",
                    color: "white"
                  }}>  {currentPoint} Points</li>
                  ) : ""}
              
            </ol>
          </nav>
        </div>
      );
    } else if (path === "/faq") {
      return (
        <div className="header-breadcrumb d-none d-md-block">
          <nav aria-label="breadcrumb">
            {authMember && authMember.success ? (
              <ol className="breadcrumb">
                <li
                  className="w-100 text-right"
                  style={{
                    listStyleType: "none",
                    paddingRight: 30,
                    fontWeight: "bold",
                  }}
                >
                  {currentPoint} Points
                </li>
              </ol>
            ) : (
              ""
            )}
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">
                  <IntlMessages id="header.home"></IntlMessages>
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                <Link to="/faq" className="active">
                  <IntlMessages id="header.faq"></IntlMessages>
                </Link>
              </li>
            </ol>
          </nav>
        </div>
      );
    } else if (path === "/term") {
      return (
        <div className="header-breadcrumb d-none d-md-block">
          <nav aria-label="breadcrumb">
            {authMember && authMember.success ? (
              <ol className="breadcrumb">
                <li
                  className="w-100 text-right"
                  style={{
                    listStyleType: "none",
                    paddingRight: 30,
                    fontWeight: "bold",
                  }}
                >
                  {currentPoint} Points
                </li>
              </ol>
            ) : (
              ""
            )}
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">
                  <IntlMessages id="header.home"></IntlMessages>
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                <Link to="/term" className="active">
                  <IntlMessages id="header.term"></IntlMessages>
                </Link>
              </li>
            </ol>
          </nav>
        </div>
      );
    } else if (path === "/contact") {
      return (
        <div className="header-breadcrumb d-none d-md-block">
          <nav aria-label="breadcrumb">
            {authMember && authMember.success ? (
              <ol className="breadcrumb">
                <li
                  className="w-100 text-right"
                  style={{
                    listStyleType: "none",
                    paddingRight: 30,
                    fontWeight: "bold",
                  }}
                >
                  {currentPoint} Points
                </li>
              </ol>
            ) : (
              ""
            )}
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">
                  <IntlMessages id="header.home"></IntlMessages>
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                <Link to="/contact" className="active">
                  <IntlMessages id="header.contact"></IntlMessages>
                </Link>
              </li>
            </ol>
          </nav>
        </div>
      );
    } else if (path === "/my-profile") {
      return (
        <div className="header-breadcrumb d-none d-md-block">
          <nav aria-label="breadcrumb">
            {authMember && authMember.success ? (
              <ol className="breadcrumb">
                <li
                  className="w-100 text-right"
                  style={{
                    listStyleType: "none",
                    paddingRight: 30,
                    fontWeight: "bold",
                  }}
                >
                  {currentPoint} Points
                </li>
              </ol>
            ) : (
              ""
            )}
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">
                  <IntlMessages id="header.home"></IntlMessages>
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                <Link to="/my-profile" className="active">
                  <IntlMessages id="header.profile"></IntlMessages>
                </Link>
              </li>
            </ol>
          </nav>
        </div>
      );
    } else if (path === "/history") {
      return (
        <div className="header-breadcrumb d-none d-md-block">
          <nav aria-label="breadcrumb">
            {authMember && authMember.success ? (
              <ol className="breadcrumb">
                <li
                  className="w-100 text-right"
                  style={{
                    listStyleType: "none",
                    paddingRight: 30,
                    fontWeight: "bold",
                  }}
                >
                  {currentPoint} Points
                </li>
              </ol>
            ) : (
              ""
            )}
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">
                  <IntlMessages id="header.home"></IntlMessages>
                </Link>
              </li>
              {/* <li className="breadcrumb-item active" aria-current="page">
                <Link to="/history" className="active">
                  <IntlMessages id="header.redeem-history"></IntlMessages>
                </Link>
              </li> */}

              {authMember && authMember.success ? (
                <li className="breadcrumb-item float-right">
                  {currentPoint} P
                </li>
              ) : (
                ""
              )}
            </ol>
          </nav>
        </div>
      );
    } else if (path === "/history/point-transfer") {
      return (
        <div className="header-breadcrumb d-none d-md-block">
          <nav aria-label="breadcrumb">
            {authMember && authMember.success ? (
              <ol className="breadcrumb">
                <li
                  className="w-100 text-right"
                  style={{
                    listStyleType: "none",
                    paddingRight: 30,
                    fontWeight: "bold",
                  }}
                >
                  {currentPoint} Points
                </li>
              </ol>
            ) : (
              ""
            )}
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">
                  <IntlMessages id="header.home"></IntlMessages>
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                <Link to="/history/point-transfer" className="active">
                  <IntlMessages id="header.point-history"></IntlMessages>
                </Link>
              </li>
            </ol>
          </nav>
        </div>
      );
    } else if (path === "/history/point-expire") {
      return (
        <div className="header-breadcrumb d-none d-md-block">
          <nav aria-label="breadcrumb">
            {authMember && authMember.success ? (
              <ol className="breadcrumb">
                <li
                  className="w-100 text-right"
                  style={{
                    listStyleType: "none",
                    paddingRight: 30,
                    fontWeight: "bold",
                  }}
                >
                  {currentPoint} Points
                </li>
              </ol>
            ) : (
              ""
            )}
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">
                  <IntlMessages id="header.home"></IntlMessages>
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                <Link to="/history/point-expire" className="active">
                  <IntlMessages id="header.point-expire"></IntlMessages>
                </Link>
              </li>
            </ol>
          </nav>
        </div>
      );
    } else {
      return (
        <div className="header-breadcrumb d-none d-md-block">
          <nav aria-label="breadcrumb">
            {authMember && authMember.success ? (
              <ol className="breadcrumb">
                <li
                  className="w-100 text-right"
                  style={{
                    listStyleType: "none",
                    paddingRight: 30,
                    fontWeight: "bold",
                  }}
                >
                  {currentPoint} Points
                </li>
              </ol>
            ) : (
              ""
            )}
            <ol className="breadcrumb">
              <li className="breadcrumb-item active">
                <Link to="/">
                  <IntlMessages id="header.home"></IntlMessages>
                </Link>
              </li>
            </ol>
          </nav>
        </div>
      );
    }
  }
}

const mapStateToProps = ({
  setting,
  auth: { authMember },
  wallet: { detail },
}) => {
  const currentPoint = detail.point;
  const { locale } = setting;
  return { locale, authMember, currentPoint };
};

export default connect(mapStateToProps, { walletDetailFetch })(Breadcrumb);
